import { hoopslab } from '@labradorsports/constants';

export const SiteConfig = hoopslab.SiteConfig;

export const GoogleAnalyticsID = 'G-7F6KTZDQZ1';

export const Sports = hoopslab.Sports;

export const SportsNames = {
    [Sports.HighSchoolBBall]: 'High-School Basketball',
    [Sports.MensCollegeBBall]: "Men's College Basketball",
    [Sports.WomensCollegeBBall]: "Women's College Basketball",
};

export const PlayerPositions = {
    POINT_GUARD: 'POINT_GUARD',
    SHOOTING_GUARD: 'SHOOTING_GUARD',
    SMALL_FORWARD: 'SMALL_FORWARD',
    POWER_FORWARD: 'POWER_FORWARD',
    CENTER: 'CENTER',
};

export const PlayerPositionNames = {
    [PlayerPositions.POINT_GUARD]: 'Point Guard',
    [PlayerPositions.SHOOTING_GUARD]: 'Shooting Guard',
    [PlayerPositions.SMALL_FORWARD]: 'Small Forward',
    [PlayerPositions.POWER_FORWARD]: 'Power Forward',
    [PlayerPositions.CENTER]: 'Center',
};

export const SportPositions = {
    [Sports.HighSchoolBBall]: [
        PlayerPositions.POINT_GUARD,
        PlayerPositions.SHOOTING_GUARD,
        PlayerPositions.SMALL_FORWARD,
        PlayerPositions.POWER_FORWARD,
        PlayerPositions.CENTER,
    ],
    [Sports.MensCollegeBBall]: [
        PlayerPositions.POINT_GUARD,
        PlayerPositions.SHOOTING_GUARD,
        PlayerPositions.SMALL_FORWARD,
        PlayerPositions.POWER_FORWARD,
        PlayerPositions.CENTER,
    ],
    [Sports.WomensCollegeBBall]: [
        PlayerPositions.POINT_GUARD,
        PlayerPositions.SHOOTING_GUARD,
        PlayerPositions.SMALL_FORWARD,
        PlayerPositions.POWER_FORWARD,
        PlayerPositions.CENTER,
    ],
};

export const EvaluationCriteria = {
    SPEED: 'SPEED',
    JUMP: 'JUMP',
    AGILITY: 'AGILITY',
    STRENGTH: 'STRENGTH',
    DRIBBLE: 'DRIBBLE',
    INSIDE_SCORING: 'INSIDE_SCORING',
    MIDRANGE_SCORING: 'MIDRANGE_SCORING',
    THREE_PT_SCORING: 'THREE_PT_SCORING',
    OFFENSIVE_REBOUND: 'OFFENSIVE_REBOUND',
    DEFENSIVE_REBOUND: 'DEFENSIVE_REBOUND',
    CATCH: 'CATCH',
    STEAL: 'STEAL',
    ONBALL_DEFENSE: 'ONBALL_DEFENSE',
    OFFBALL_DEFENSE: 'OFFBALL_DEFENSE',
    BLOCK: 'BLOCK',
    COURT_VISION: 'COURT_VISION',
    OFFENSE_IQ: 'OFFENSE_IQ',
    DEFENSE_IQ: 'DEFENSE_IQ',
    CONDITIONING: 'CONDITIONING',
    GRIT: 'GRIT',
};

export const PointGuardWeights = {
    [EvaluationCriteria.SPEED]: 6.7,
    [EvaluationCriteria.JUMP]: 4,
    [EvaluationCriteria.AGILITY]: 6.7,
    [EvaluationCriteria.STRENGTH]: 2.7,
    [EvaluationCriteria.DRIBBLE]: 6.7,
    [EvaluationCriteria.INSIDE_SCORING]: 2,
    [EvaluationCriteria.MIDRANGE_SCORING]: 4.7,
    [EvaluationCriteria.THREE_PT_SCORING]: 4.7,
    [EvaluationCriteria.OFFENSIVE_REBOUND]: 2.7,
    [EvaluationCriteria.DEFENSIVE_REBOUND]: 2.7,
    [EvaluationCriteria.CATCH]: 4.7,
    [EvaluationCriteria.STEAL]: 4.7,
    [EvaluationCriteria.ONBALL_DEFENSE]: 6.7,
    [EvaluationCriteria.OFFBALL_DEFENSE]: 6.7,
    [EvaluationCriteria.BLOCK]: 1.9,
    [EvaluationCriteria.COURT_VISION]: 6.7,
    [EvaluationCriteria.OFFENSE_IQ]: 6.7,
    [EvaluationCriteria.DEFENSE_IQ]: 5.3,
    [EvaluationCriteria.CONDITIONING]: 6.7,
    [EvaluationCriteria.GRIT]: 6.7,
};

export const ShootingGuardWeights = {
    [EvaluationCriteria.SPEED]: 5.2,
    [EvaluationCriteria.JUMP]: 5.2,
    [EvaluationCriteria.AGILITY]: 5.8,
    [EvaluationCriteria.STRENGTH]: 2.6,
    [EvaluationCriteria.DRIBBLE]: 5.8,
    [EvaluationCriteria.INSIDE_SCORING]: 3.2,
    [EvaluationCriteria.MIDRANGE_SCORING]: 4.5,
    [EvaluationCriteria.THREE_PT_SCORING]: 5.8,
    [EvaluationCriteria.OFFENSIVE_REBOUND]: 3.9,
    [EvaluationCriteria.DEFENSIVE_REBOUND]: 3.9,
    [EvaluationCriteria.CATCH]: 4.5,
    [EvaluationCriteria.STEAL]: 4.5,
    [EvaluationCriteria.ONBALL_DEFENSE]: 6.5,
    [EvaluationCriteria.OFFBALL_DEFENSE]: 6.5,
    [EvaluationCriteria.BLOCK]: 5.2,
    [EvaluationCriteria.COURT_VISION]: 5.2,
    [EvaluationCriteria.OFFENSE_IQ]: 5.2,
    [EvaluationCriteria.DEFENSE_IQ]: 5.2,
    [EvaluationCriteria.CONDITIONING]: 5.2,
    [EvaluationCriteria.GRIT]: 6.5,
};

export const SmallForwardWeights = {
    [EvaluationCriteria.SPEED]: 4.2,
    [EvaluationCriteria.JUMP]: 5.4,
    [EvaluationCriteria.AGILITY]: 5.4,
    [EvaluationCriteria.STRENGTH]: 4.2,
    [EvaluationCriteria.DRIBBLE]: 5.4,
    [EvaluationCriteria.INSIDE_SCORING]: 4.2,
    [EvaluationCriteria.MIDRANGE_SCORING]: 4.7,
    [EvaluationCriteria.THREE_PT_SCORING]: 4.7,
    [EvaluationCriteria.OFFENSIVE_REBOUND]: 4.7,
    [EvaluationCriteria.DEFENSIVE_REBOUND]: 4.7,
    [EvaluationCriteria.CATCH]: 4.7,
    [EvaluationCriteria.STEAL]: 4.7,
    [EvaluationCriteria.ONBALL_DEFENSE]: 6.7,
    [EvaluationCriteria.OFFBALL_DEFENSE]: 6.7,
    [EvaluationCriteria.BLOCK]: 3.2,
    [EvaluationCriteria.COURT_VISION]: 4.2,
    [EvaluationCriteria.OFFENSE_IQ]: 5.4,
    [EvaluationCriteria.DEFENSE_IQ]: 5.4,
    [EvaluationCriteria.CONDITIONING]: 5.4,
    [EvaluationCriteria.GRIT]: 6.7,
};

export const PowerForwardWeights = {
    [EvaluationCriteria.SPEED]: 2.8,
    [EvaluationCriteria.JUMP]: 3.5,
    [EvaluationCriteria.AGILITY]: 4.3,
    [EvaluationCriteria.STRENGTH]: 5.7,
    [EvaluationCriteria.DRIBBLE]: 3.5,
    [EvaluationCriteria.INSIDE_SCORING]: 7.1,
    [EvaluationCriteria.MIDRANGE_SCORING]: 3.5,
    [EvaluationCriteria.THREE_PT_SCORING]: 2.8,
    [EvaluationCriteria.OFFENSIVE_REBOUND]: 7.1,
    [EvaluationCriteria.DEFENSIVE_REBOUND]: 7.1,
    [EvaluationCriteria.CATCH]: 5,
    [EvaluationCriteria.STEAL]: 2.1,
    [EvaluationCriteria.ONBALL_DEFENSE]: 7.1,
    [EvaluationCriteria.OFFBALL_DEFENSE]: 7.1,
    [EvaluationCriteria.BLOCK]: 5.7,
    [EvaluationCriteria.COURT_VISION]: 2.8,
    [EvaluationCriteria.OFFENSE_IQ]: 5.7,
    [EvaluationCriteria.DEFENSE_IQ]: 5.7,
    [EvaluationCriteria.CONDITIONING]: 4.3,
    [EvaluationCriteria.GRIT]: 7.1,
};

export const CenterWeights = {
    [EvaluationCriteria.SPEED]: 2.9,
    [EvaluationCriteria.JUMP]: 3.6,
    [EvaluationCriteria.AGILITY]: 4.3,
    [EvaluationCriteria.STRENGTH]: 5.8,
    [EvaluationCriteria.DRIBBLE]: 3.6,
    [EvaluationCriteria.INSIDE_SCORING]: 7.2,
    [EvaluationCriteria.MIDRANGE_SCORING]: 3.6,
    [EvaluationCriteria.THREE_PT_SCORING]: 1.4,
    [EvaluationCriteria.OFFENSIVE_REBOUND]: 7.2,
    [EvaluationCriteria.DEFENSIVE_REBOUND]: 7.2,
    [EvaluationCriteria.CATCH]: 5,
    [EvaluationCriteria.STEAL]: 2.2,
    [EvaluationCriteria.ONBALL_DEFENSE]: 7.2,
    [EvaluationCriteria.OFFBALL_DEFENSE]: 7.2,
    [EvaluationCriteria.BLOCK]: 5.8,
    [EvaluationCriteria.COURT_VISION]: 2.9,
    [EvaluationCriteria.OFFENSE_IQ]: 5.8,
    [EvaluationCriteria.DEFENSE_IQ]: 5.8,
    [EvaluationCriteria.CONDITIONING]: 4.3,
    [EvaluationCriteria.GRIT]: 7.2,
};

export const PlayerRatingWeights = {
    [PlayerPositions.POINT_GUARD]: PointGuardWeights,
    [PlayerPositions.SHOOTING_GUARD]: ShootingGuardWeights,
    [PlayerPositions.SMALL_FORWARD]: SmallForwardWeights,
    [PlayerPositions.POWER_FORWARD]: PowerForwardWeights,
    [PlayerPositions.CENTER]: CenterWeights,
};

export const PlayerRatingSections = [
    {
        id: 'athleticism',
        sectionName: 'Athleticism',
        criteria: [
            { id: EvaluationCriteria.SPEED, criteriaLabel: 'Speed' },
            { id: EvaluationCriteria.JUMP, criteriaLabel: 'Jump' },
            { id: EvaluationCriteria.AGILITY, criteriaLabel: 'Agility' },
            { id: EvaluationCriteria.STRENGTH, criteriaLabel: 'Strength' },
        ],
    },
    {
        id: 'skills',
        sectionName: 'Skills',
        criteria: [
            { id: EvaluationCriteria.DRIBBLE, criteriaLabel: 'Dribble' },
            { id: EvaluationCriteria.INSIDE_SCORING, criteriaLabel: 'Inside Scoring' },
            { id: EvaluationCriteria.MIDRANGE_SCORING, criteriaLabel: 'Mid-Range Scoring' },
            { id: EvaluationCriteria.THREE_PT_SCORING, criteriaLabel: '3-PT Scoring' },
            { id: EvaluationCriteria.OFFENSIVE_REBOUND, criteriaLabel: 'Offensive Rebound' },
            { id: EvaluationCriteria.DEFENSIVE_REBOUND, criteriaLabel: 'Defensive Rebound' },
            { id: EvaluationCriteria.CATCH, criteriaLabel: 'Catch' },
            { id: EvaluationCriteria.STEAL, criteriaLabel: 'Steal' },
            { id: EvaluationCriteria.ONBALL_DEFENSE, criteriaLabel: 'On-Ball Defense' },
            { id: EvaluationCriteria.OFFBALL_DEFENSE, criteriaLabel: 'Off-Ball Defense' },
            { id: EvaluationCriteria.BLOCK, criteriaLabel: 'Block' },
        ],
    },
    {
        id: 'awareness',
        sectionName: 'Awareness',
        criteria: [
            { id: EvaluationCriteria.COURT_VISION, criteriaLabel: 'Court Vision' },
            { id: EvaluationCriteria.OFFENSE_IQ, criteriaLabel: 'Offense IQ' },
            { id: EvaluationCriteria.DEFENSE_IQ, criteriaLabel: 'Defense IQ' },
        ],
    },
    {
        id: 'intangibles',
        sectionName: 'Intangibles',
        criteria: [
            { id: EvaluationCriteria.CONDITIONING, criteriaLabel: 'Conditioning' },
            { id: EvaluationCriteria.GRIT, criteriaLabel: 'Grit' },
        ],
    },
];

export const PlayTags = [
    'Offense',
    'Defense',
    'Press',
    'Press Break',
    'Out-of-Bounds',
    'Ball Handling',
    'Read-and-React',
    'Transition',
];

export const DepthSections = {
    starters: 'starters',
};

export const DepthConfig: any = {
    [Sports.HighSchoolBBall]: {
        [DepthSections.starters]: {
            name: 'Starters',
            starters: 5,
        },
    },
    [Sports.MensCollegeBBall]: {
        [DepthSections.starters]: {
            name: 'Starters',
            starters: 5,
        },
    },
    [Sports.WomensCollegeBBall]: {
        [DepthSections.starters]: {
            name: 'Starters',
            starters: 5,
        },
    },
};

export const DepthChartLayout = {
    [Sports.HighSchoolBBall]: [[DepthSections.starters]],
    [Sports.MensCollegeBBall]: [[DepthSections.starters]],
    [Sports.WomensCollegeBBall]: [[DepthSections.starters]],
};

// No variation from roster display names
export const PlayerRoleNames = PlayerPositionNames;

export const TeamSizes = hoopslab.TeamSizes;

export const PlanNames = hoopslab.PlanNames;

export const AddonConfig = hoopslab.AddonConfig;

export const ScoutingReportStats = {
    GAMES: 'GAMES',
    TOTAL_POINTS: 'TOTAL_POINTS',
    POINTS_PER_GAME: 'POINTS_PER_GAME',
    SCORING_MARGIN: 'SCORING_MARGIN',
    FG_MADE_ATTEMPTED: 'FG_MADE_ATTEMPTED',
    FG_PCT: 'FG_PCT',
    FG_PER_GAME: 'FG_PER_GAME',
    _3PT_MADE_ATTEMPTED: '_3PT_MADE_ATTEMPTED',
    _3PT_PCT: '_3PT_PCT',
    _3PT_PER_GAME: '_3PT_PER_GAME',
    FT_MADE_ATTEMPTED: 'FT_MADE_ATTEMPTED',
    FT_PCT: 'FT_PCT',
    FT_PER_GAME: 'FT_PER_GAME',
    REBOUND_TOTAL: 'REBOUND_TOTAL',
    REBOUND_PER_GAME: 'REBOUND_PER_GAME',
    REBOUND_MARGIN: 'REBOUND_MARGIN',
    ASSISTS_TOTAL: 'ASSISTS_TOTAL',
    ASSISTS_PER_GAME: 'ASSISTS_PER_GAME',
    TURNOVERS_TOTAL: 'TURNOVERS_TOTAL',
    TURNOVERS_PER_GAME: 'TURNOVERS_PER_GAME',
    TURNOVERS_MARGIN: 'TURNOVERS_MARGIN',
    ASSIST_TURNOVER_RATIO: 'ASSIST_TURNOVER_RATIO',
    POINTS_OFF_TURNOVERS: 'POINTS_OFF_TURNOVERS',
};

export const ScoutingReportStatDetails = {
    [ScoutingReportStats.GAMES]: {
        key: ScoutingReportStats.GAMES,
        name: 'Games',
        shortKey: 'GP',
    },
    [ScoutingReportStats.TOTAL_POINTS]: {
        key: ScoutingReportStats.TOTAL_POINTS,
        shortKey: 'PTS',
        name: 'Total Points',
    },
    [ScoutingReportStats.POINTS_PER_GAME]: {
        key: ScoutingReportStats.POINTS_PER_GAME,
        name: 'Points Per Game',
        formula: [ScoutingReportStats.TOTAL_POINTS, '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.SCORING_MARGIN]: {
        key: ScoutingReportStats.SCORING_MARGIN,
        name: 'Scoring Margin',
    },
    [ScoutingReportStats.FG_MADE_ATTEMPTED]: {
        key: ScoutingReportStats.FG_MADE_ATTEMPTED,
        name: 'FG: Made-Attempted',
        format: '-',
    },
    [ScoutingReportStats.FG_PCT]: {
        key: ScoutingReportStats.FG_PCT,
        name: 'FG: Percentage',
        formula: ['a-b', ScoutingReportStats.FG_MADE_ATTEMPTED, 'a', '/', 'b'],
    },
    [ScoutingReportStats.FG_PER_GAME]: {
        key: ScoutingReportStats.FG_PER_GAME,
        name: 'FG: Per Game',
        formula: ['a-b', ScoutingReportStats.FG_MADE_ATTEMPTED, 'a', '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats._3PT_MADE_ATTEMPTED]: {
        key: ScoutingReportStats._3PT_MADE_ATTEMPTED,
        name: '3PT: Made-Attempted',
        format: '-',
    },
    [ScoutingReportStats._3PT_PCT]: {
        key: ScoutingReportStats._3PT_PCT,
        name: '3PT: Percentage',
        formula: ['a-b', ScoutingReportStats._3PT_MADE_ATTEMPTED, 'a', '/', 'b'],
    },
    [ScoutingReportStats._3PT_PER_GAME]: {
        key: ScoutingReportStats._3PT_PER_GAME,
        name: '3PT: Per Game',
        formula: ['a-b', ScoutingReportStats._3PT_MADE_ATTEMPTED, 'a', '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.FT_MADE_ATTEMPTED]: {
        key: ScoutingReportStats.FT_MADE_ATTEMPTED,
        name: 'FT: Made-Attempted',
        format: '-',
    },
    [ScoutingReportStats.FT_PCT]: {
        key: ScoutingReportStats.FT_PCT,
        name: 'FT: Percentage',
        formula: ['a-b', ScoutingReportStats.FT_MADE_ATTEMPTED, 'a', '/', 'b'],
    },
    [ScoutingReportStats.FT_PER_GAME]: {
        key: ScoutingReportStats.FT_PER_GAME,
        name: 'FT: Per Game',
        formula: ['a-b', ScoutingReportStats.FT_MADE_ATTEMPTED, 'a', '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.REBOUND_TOTAL]: {
        key: ScoutingReportStats.REBOUND_TOTAL,
        shortKey: 'RB',
        name: 'Total Rebounds',
    },
    [ScoutingReportStats.REBOUND_PER_GAME]: {
        key: ScoutingReportStats.REBOUND_PER_GAME,
        name: 'Rebounds Per Game',
        formula: [ScoutingReportStats.REBOUND_TOTAL, '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.REBOUND_MARGIN]: {
        key: ScoutingReportStats.REBOUND_MARGIN,
        name: 'Margin',
    },
    [ScoutingReportStats.ASSISTS_TOTAL]: {
        key: ScoutingReportStats.ASSISTS_TOTAL,
        shortKey: 'AST',
        name: 'Total Assists',
    },
    [ScoutingReportStats.ASSISTS_PER_GAME]: {
        key: ScoutingReportStats.ASSISTS_PER_GAME,
        name: 'Assists Per Game',
        formula: [ScoutingReportStats.ASSISTS_TOTAL, '/', ScoutingReportStats.GAMES],
    },
    [ScoutingReportStats.TURNOVERS_TOTAL]: {
        key: ScoutingReportStats.TURNOVERS_TOTAL,
        shortKey: 'TO',
        name: 'Total Turnovers',
        lowerIsBetter: true,
    },
    [ScoutingReportStats.TURNOVERS_PER_GAME]: {
        key: ScoutingReportStats.TURNOVERS_PER_GAME,
        name: 'Turnovers Per Game',
        formula: [ScoutingReportStats.TURNOVERS_TOTAL, '/', ScoutingReportStats.GAMES],
        lowerIsBetter: true,
    },
    [ScoutingReportStats.TURNOVERS_MARGIN]: {
        key: ScoutingReportStats.TURNOVERS_MARGIN,
        name: 'Margin',
    },
    [ScoutingReportStats.ASSIST_TURNOVER_RATIO]: {
        key: ScoutingReportStats.ASSIST_TURNOVER_RATIO,
        name: 'Assist/Turnover Ratio',
        formula: [ScoutingReportStats.ASSISTS_TOTAL, '/', ScoutingReportStats.TURNOVERS_TOTAL],
    },
    [ScoutingReportStats.POINTS_OFF_TURNOVERS]: {
        key: ScoutingReportStats.POINTS_OFF_TURNOVERS,
        name: 'Points Off Turnovers',
    },
};

const bballScoutingReportStats = [
    {
        categoryName: 'PREVIEW',
        stats: [ScoutingReportStats.GAMES, ScoutingReportStats.TOTAL_POINTS, ScoutingReportStats.POINTS_PER_GAME],
    },
    {
        categoryName: 'Scoring',
        stats: [
            ScoutingReportStats.GAMES,
            ScoutingReportStats.TOTAL_POINTS,
            ScoutingReportStats.POINTS_PER_GAME,
            ScoutingReportStats.SCORING_MARGIN,
        ],
    },
    {
        categoryName: 'Shooting',
        stats: [
            ScoutingReportStats.FG_MADE_ATTEMPTED,
            ScoutingReportStats.FG_PCT,
            ScoutingReportStats.FG_PER_GAME,
            ScoutingReportStats._3PT_MADE_ATTEMPTED,
            ScoutingReportStats._3PT_PCT,
            ScoutingReportStats._3PT_PER_GAME,
            ScoutingReportStats.FT_MADE_ATTEMPTED,
            ScoutingReportStats.FT_PCT,
            ScoutingReportStats.FT_PER_GAME,
        ],
    },
    {
        categoryName: 'Rebounding',
        stats: [
            ScoutingReportStats.REBOUND_TOTAL,
            ScoutingReportStats.REBOUND_PER_GAME,
            ScoutingReportStats.REBOUND_MARGIN,
        ],
    },
    {
        categoryName: 'Assists',
        stats: [ScoutingReportStats.ASSISTS_TOTAL, ScoutingReportStats.ASSISTS_PER_GAME],
    },
    {
        categoryName: 'Turnovers',
        stats: [
            ScoutingReportStats.TURNOVERS_TOTAL,
            ScoutingReportStats.TURNOVERS_PER_GAME,
            ScoutingReportStats.TURNOVERS_MARGIN,
            ScoutingReportStats.ASSIST_TURNOVER_RATIO,
            ScoutingReportStats.POINTS_OFF_TURNOVERS,
        ],
    },
];

export const ScoutingReportStatDisplay = {
    [Sports.HighSchoolBBall]: bballScoutingReportStats,
    [Sports.MensCollegeBBall]: bballScoutingReportStats,
    [Sports.WomensCollegeBBall]: bballScoutingReportStats,
};

export const PersonnelQuickStats = [
    ScoutingReportStats.GAMES,
    ScoutingReportStats.TOTAL_POINTS,
    ScoutingReportStats.ASSISTS_TOTAL,
    ScoutingReportStats.REBOUND_TOTAL,
    ScoutingReportStats.TURNOVERS_TOTAL,
];

export const Features = hoopslab.Features;

const Config: ConfigSpec = {
    SiteConfig,
    GoogleAnalyticsID,
    Sports,
    PlayTags,
    SportsNames,
    PlayerPositions,
    PlayerRatingWeights,
    DepthSections,
    DepthConfig,
    DepthChartLayout,
    PlayerPositionNames,
    PlayerRatingSections,
    SportPositions,
    PlayerRoleNames,
    TeamSizes,
    PlanNames,
    AddonConfig,
    ScoutingReportStats,
    ScoutingReportStatDetails,
    ScoutingReportStatDisplay,
    PersonnelQuickStats,
    Features,
};

export default Config;
